// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
import React, { useContext } from 'react';
import { useLocalize } from '@ta/platform.i18n';
import { Environment } from '@ta/lithium.context';
import styles from './AddCta.css';

type Props = {|
  onClick: () => mixed,
|};

/**
 * A CTA to start the Explicit Preferences flow for the first time
 */
const EditCta = ({ onClick }: Props) => {
  const { localize } = useLocalize();
  const { cdnPrefix } = useContext(Environment);

  return (
    <div className={styles.addCta}>
      <img
        className={styles.icon}
        src={`${cdnPrefix}/img2/cx/explicit_preferences/plane.svg`}
        alt=""
      />
      <div className={styles.header}>
        {localize('cx_explicit_preferences_cta_header') /* Tell us about your trip */}
      </div>
      <div className={styles.subheader}>
        {/* You'll see personalized ideas from other travelers like you. */}
        {localize('cx_explicit_preferences_cta_subheader3')}
      </div>
      <button className={styles.getStarted} onClick={onClick}>
        {localize('onboarding_social_brand_splash_get_started_cta') /* Get started */}
      </button>
    </div>
  );
};

export default EditCta;
